<template>
  <div class="index-wrap" ref="container">
    <div class="btn">
      <div class="rule" v-log="'click_rule'" @click="handleRule"></div>
      <div class="rank" v-log="'click_rank'" @click="handleRank"></div>
      <div class="prize" v-log="'click_prize'" @click="handlePrize"></div>
      <div class="start" v-log="'game_start'" @click="handleStart"></div>
    </div>
    <transition name="toastShow">
      <div class="toast" v-if="toastMsg">{{toastMsg}}</div>
    </transition>
    <div class="dialogs" v-if="visibleDialog">
      <div class="rule-wrap" v-if="visibleRule">
        <div class="title">
          <div class="split"></div>活动规则
          <div class="split"></div>
        </div>
        <div class="content" v-html="activity.content"></div>
        <div class="close" @click="visibleRule = false"></div>
      </div>
      <div class="rank-wrap" v-if="visibleRank">
        <div class="title">排行榜</div>
        <div class="content">
          <div class="header item">
            <div class="rank-num">排名</div>
            <div class="nickname">昵称</div>
            <div class="num">邀请人数</div>
          </div>
          <div class="my-rank item" v-if="rank.my">
            <div class="rank-num">{{rank.my.ranking}}</div>
            <div class="nickname">{{rank.my.nickname}}</div>
            <div class="num">{{rank.my.count}}</div>
          </div>
          <div class="list" :class="{'has-my': rank.my}">
            <list
              class="rank-list"
              v-model="rank.loading"
              :finished="rank.finished"
              finished-text="没有更多了"
              @load="getRankData"
            >
              <div class="item" v-for="(item, index) in rank.list" :key="index">
                <div class="rank-num">{{index+1}}</div>
                <div class="nickname">{{item.nickname}}</div>
                <div class="num">{{item.count}}</div>
              </div>
            </list>
          </div>
        </div>
        <div class="close" @click="visibleRank = false"></div>
      </div>
      <div class="prize-wrap" ref="prize" v-if="visiblePrize">
        <div class="title">我的奖品</div>
        <div class="list-wrap" v-if="!currentPrize">
          <div class="title">奖品名称</div>
          <div class="list">
            <div class="item" v-for="(item, index) in prizeList" :key="index">
              <div class="name">{{item.prize_name}}</div>
              <div class="status">
                <span v-if="item.status===3">已领取</span>
                <button v-else class="enroll" @click="handleEnroll(item)"></button>
              </div>
            </div>
            <!-- <input type="text"> -->
          </div>
        </div>
        <!-- (!prizeInfo || !prizeInfo.name) &&  -->
        <div class="form-wrap" v-if="currentPrize">
          <div class="title">{{currentPrize.prize_name}}</div>
          <div class="form" :class="{'no-address':currentPrize.type !== 1, 'error-form':errorForm}">
            <div class="input-tips">
              请输入您的有效手机号码， 后续奖品卡号密码将通过短信通知告知您！
            </div>
            <div class="input-wrap input-name">
              <input
                @blur="blurInput"
                v-model="form.name"
                type="text"
                class="input"
                required
                :placeholder="'请输入收件人姓名'"
              />
            </div>
            <div class="input-wrap input-address">
              <input
                @blur="blurInput"
                v-model="form.address"
                type="text"
                class="input"
                required
                placeholder="请输入收件地址"
              />
            </div>
            <div class="input-wrap">
              <input
                @blur="blurInput"
                v-model="form.phone"
                type="number"
                class="input"
                @input="inputPhone"
                maxlength="11"
                required
                placeholder="请输入手机号码"
              />
            </div>
          </div>
          <div class="button-wrap">
            <button class="submit" @click="submitForm"></button>
          </div>
        </div>
        <div class="tips" v-if="!currentPrize">温馨提示：除红包奖品，其他类型奖品需点击领取， 根据提示进行奖品领取</div>
        <div class="tips" v-else>温馨提示：点击提交后不可再修改， 请仔细检查后再提交</div>
        <div class="close" @click="handleClosePrize"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { List, Dialog } from 'vant'
import Code from '@/mixins/code'

export default {
  name: 'index',
  components: { List },
  mixins: [Code],
  data() {
    return {
      visibleRule: false,
      visibleRank: false,
      visiblePrize: false,
      rank: {
        my: null,
        list: [],
        page: 1,
        loading: false,
        finished: false
      },
      toastMsg: '',
      prizeList: [],
      prizeInfo: {},
      currentPrize: null,
      form: {},
      errorForm: false
    }
  },
  computed: {
    phone: {
      get () {
        return this.form.phone
      },
      set (val) {
        if (val.length > 11) {
          return
        }
        console.log(val)
        this.form.phone = val
      }
    },
    visibleDialog() {
      return this.visibleRule || this.visibleRank || this.visiblePrize || this.toastMsg
    }
  },
  watch: {
  },
  methods: {
    inputPhone(event) {
      // 只能是正整数或空,可根据需求修改正则
      const filtered = event.target.value.replace(/^0|1[^\d]/g, '')
      if (this.form.phone !== filtered) {
        this.form.phone = filtered.slice(0, 11)
      }
      this.form.phone = this.form.phone.slice(0, 11)
      event.target.value = this.form.phone
    },
    async submitForm() {
      this.blurInput()
      const form = this.form
      for (const key in form) {
        if (!form[key]) {
          this.errorForm = true
          return
        }
      }
      this.$stat({
        event: 'click_write_submit'
      })
      form.able_type = this.activity.package_name
      form.user_prize_id = this.currentPrize.user_prize_id
      await this.$fetch.post('/lottery/address', form)
      this.showToast('提交成功')
      this.currentPrize = null
      this.visiblePrize = false
    },
    async getRankData() {
      try {
        this.$set(this.rank, 'loading', true)
        const { data } = await this.$fetch.get('/looking-for-friend/my-ranking', {
          page: this.rank.page++
        })
        console.log(data)
        this.rank.my = data.meta.user_ranking || null
        this.rank.list.push(...data.data)
        if (!data.data || !data.data.length) {
          this.$set(this.rank, 'finished', true)
        }
      } catch (e) {
        this.$set(this.rank, 'finished', true)
      }
      this.$set(this.rank, 'loading', false)
    },
    checkTimeStatus(time) {
      if (!time) {
        return 0
      }
      const date = +new Date(time.replace(/-/g, '/'))
      const now = +new Date()
      return +(date > now)
    },
    checkActivityTime() {
      if (this.checkTimeStatus(this.activity.start_time)) {
        return 1
      }
      if (!this.checkTimeStatus(this.activity.end_time)) {
        return 2
      }
      return 0
    },
    init(check = true) {
      const status = this.checkActivityTime()
      const act = ['未开始', '已结束']
      if (status) {
        Dialog.alert({
          message: `活动${act[status - 1]}`
        })
        return
      }
      return true
    },
    handleStart () {
      if (!this.activity.is_subscribe) {
        this.$parent.visibleQrcode = true
        return
      }
      if (!this.init()) {
        return
      }
      this.$parent.$refs.bgm.play()
      this.$router.push('loading')
    },
    handleEnroll(item) {
      this.$stat({
        event: 'prize_to_write',
        data: {
          name: item.prize_name
        }
      })
      if (item.ticket) {
        console.log(item.ticket)
        const ticket = encodeURIComponent(item.ticket)
        const ticketUrl = process.env.VUE_APP_TICKET_URL
        console.log(ticketUrl)
        location.href = `${ticketUrl}${ticket}`
        return
      }
      this.form = { name: '', address: '', phone: '' }
      if (item.type !== 1) {
        delete this.form.address
        delete this.form.name
      }
      this.currentPrize = item
      this.$nextTick(() => {
        this.$parent.changeInputWrap(this.$refs.prize)
      })
    },
    handleRule() {
      this.visibleRule = true
    },
    handleRank() {
      this.visibleRank = true
    },
    showToast (msg) {
      this.toastMsg = msg
      setTimeout(() => {
        this.toastMsg = ''
      }, 2000)
    },
    async handlePrize() {
      const { data } = await this.$fetch.post('/lottery/my/prizes', {
        able_type: this.activity.package_name
      })
      this.prizeList = data.user_prizes
      this.prizeInfo = data.user_address
      console.log(data)
      this.visiblePrize = true
    },
    handleClosePrize() {
      this.visiblePrize = false
      this.currentPrize = null
      this.errorForm = false
    }
  },
  mounted() {
    this.$parent.setDevice(this.$refs.container)
  }
}
</script>

<style lang='scss' scoped>
.toastShow-enter-active {
  transition: all 1s ease;
}
.toastShow-leave-active {
  transition: all 1s ease;
}
.toastShow-enter,
.toastShow-leave-to {
  transform: scale(0);
  opacity: 1;
}
.index-wrap {
  background: url(~@/assets/img/首页bg.png) no-repeat;
  background-size: auto 100%;
  background-position: center 0;
  overflow: hidden;
  .dialogs {
    background: rgba(0, 0, 0, 0.6);
    z-index: 999;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .close {
      position: absolute;
      background: url(~@/assets/img/关.png) no-repeat;
      background-size: 100%;
      width: 42px;
      height: 42px;
      right: -42px;
      top: 0;
    }
    .rule-wrap {
      background: url(~@/assets/img/活动规则bg.png) no-repeat;
      background-size: 100% 100%;
      width: 826px;
      height: 596px;
      position: relative;
      .title {
        text-align: center;
        width: 100%;
        height: 120px;
        font-size: 66px;
        line-height: 120px;
        color: #e35640;
        font-weight: bold;
        .split {
          display: inline-block;
          margin: 20px 46px;
          width: 168px;
          height: 5px;
          background: #e35640;
        }
      }
      .content {
        width: 675px;
        height: 341px;
        overflow-y: scroll;
        font-size: 24px;
        color: #e35640;
        margin: 30px auto;
      }
      ::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 10px;
        right: -20px;
      }
      ::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 10px;
        // box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: #e35640;
      }
      ::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        // box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        background: #fff7e1;
      }
    }
    .rank-wrap {
      background: #ffeac2;
      width: 551px;
      height: 520px;
      border-radius: 10px;
      position: relative;
      font-size: 24px;
      color: #e35640;
      .title {
        text-align: center;
        width: 100%;
        height: 120px;
        font-size: 66px;
        line-height: 120px;
        font-weight: bold;
        color: #e35640;
      }
      .content {
        height: 400px;
        .list {
          height: 320px;
          overflow: auto;
          &.has-my {
            height: 240px;
          }
        }
        .item {
          display: flex;
          height: 70px;
          line-height: 70px;
          .rank-num {
            width: 110px;
            text-align: center;
          }
          .nickname {
            flex: 1;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            text-align: center;
          }
          .num {
            width: 150px;
            text-align: center;
          }
        }
        .my-rank {
          background: #ffeb91;
          margin: 5px 0;
        }
        .header {
          background: #fbc39f;
          height: 70px;
          line-height: 70px;
          font-size: 26px;
          color: #e35640;
        }
      }
    }
    .prize-wrap {
      background: url(~@/assets/img/bg.png) no-repeat;
      background-size: 100%;
      width: 659px;
      height: 658px;
      position: relative;
      padding: 30px 0;
      color: #c94e41;
      font-size: 24px;
      .title {
        text-align: center;
        width: 100%;
        height: 120px;
        font-size: 66px;
        line-height: 120px;
        font-weight: bold;
      }
      .list-wrap {
        width: 415px;
        background: #fff;
        border-radius: 20px;
        margin: 50px auto;
        padding: 0 15px;
        .title {
          font-size: 28px;
          height: 60px;
          line-height: 60px;
          text-align: left;
          border-bottom: 1px solid rgba(255, 188, 170, 1);
        }
        .list {
          height: 250px;
          overflow: auto;
          .item {
            display: flex;
            align-items: center;
            height: 56px;
            .name {
              flex: 1;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .status {
              font-size: 18px;
            }
            .enroll {
              background: url(~@/assets/img/领取按钮.png) no-repeat;
              background-size: 100%;
              width: 125px;
              height: 37px;
              border: none;
            }
          }
        }
      }
      .form-wrap {
        width: 415px;
        margin: 0 auto;
        padding-top: 30px;
        position: relative;
        .title {
          font-size: 30px;
          height: 60px;
          line-height: 60px;
        }
        .form {
          height: 220px;
          &.no-address {
            padding-top: 10px;
            .input-name {
              display: none;
            }
            .input-address {
              display: none;
            }
            .input-tips {
              display: block;
              width: 417px;
              text-align: center;
              margin: 20px auto 10px;
            }
          }
          &.error-form {
            .input::placeholder {
              color: #ee0a24;
            }
          }
        }
        .input-tips {
          display: none;
        }
        .input-wrap {
          width: 413px;
          height: 56px;
          margin: 0 auto 25px;
          // display: flex;
          position: relative;
          .input {
            width: 413px;
            height: 56px;
            background: #ffffff;
            border-radius: 5px;
            font-size: 24px;
            padding: 17px 15px;
            display: block;
          }
        }
        .button-wrap {
          text-align: center;
          margin: 16px auto 30px;
          .submit {
            background: url(~@/assets/img/提交按钮.png) no-repeat;
            background-size: 100%;
            width: 184px;
            height: 53px;
            border: none;
          }
        }
      }

      .tips {
        width: 475px;
        text-align: center;
        margin: 0 auto;
      }
    }
  }
  .btn {
    z-index: -1;
    width: 100%;
    height: 200px;
    position: absolute;
    div {
      position: absolute;
    }
    .start {
      background: url(~@/assets/img/开始按钮.png) no-repeat;
      background-size: 100%;
      width: 295px;
      height: 82px;
      left: 50%;
      transform: translateX(-50%);
      top: 556px;
      animation: startGame infinite 1.3s;
      // transform-origin: right bottom;
    }
    @keyframes startGame {
      0% {
        transform: scale(1) translateX(-50%);
      }
      50% {
        transform: scale(1.1) translateX(-50%);
      }
      100% {
        transform: scale(1) translateX(-50%);
      }
    }
    .rule {
      background: url(~@/assets/img/活动规则.png) no-repeat;
      background-size: 100%;
      width: 191px;
      height: 42px;
      left: -40px;
      top: 23px;
    }
    .rank {
      background: url(~@/assets/img/排行榜.png) no-repeat;
      background-size: 100%;
      width: 200px;
      height: 42px;
      left: -50px;
      top: 85px;
    }
    .prize {
      background: url(~@/assets/img/我的奖品按钮.png) no-repeat;
      background-size: 100%;
      width: 150px;
      height: 43px;
      // top: 21px;
      top: 140px;
      left: 0;
    }
  }
  .toast {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0,0,0,.7);
    padding: 10px 20px;
    font-size: 36px;
    z-index: 9999;
    color: #fff;
    border-radius: 10px;
  }
}
</style>
